export default "__VITE_ASSET__CQI0ociO__"